import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {FormGroupBuilderService} from "./services/form-group-builder.service";
import {RqFormFieldComponent} from "./rq-form-field/rq-form-field.component";
import {Field} from "./interfaces/field";
import {CardModule} from "primeng/card";
import {DropdownModule} from "primeng/dropdown";
import {InputTextModule} from "primeng/inputtext";
import {PrimeTemplate} from "primeng/api";
import {TramiteRequisitoRq} from "../../../../users/tramites/components/interfaces/tramites.interface";
import {FieldsParserService} from "./services/fields-parser.service";
import {Observable} from "rxjs";
import {transformFormToJson} from "./interfaces/field-types";

@Component({
    selector: 'rq-form',
    templateUrl: './rq-form.component.html',
    providers: [FormGroupBuilderService],
    imports: [CommonModule, RqFormFieldComponent, ReactiveFormsModule, CardModule, DropdownModule, InputTextModule, PrimeTemplate],
    standalone: true
})
export class RqFormComponent implements OnInit {
    fields: Field<string>[] | null = [];
    fields$: Observable<Field<any>[]> | undefined;
    form!: FormGroup;
    payLoad = '';
    @Input() rq!: TramiteRequisitoRq;
    @Input() onSubmitTemplate!: TemplateRef<any | null>;
    @Output() onSubmitEmitter = new EventEmitter<{ rq: TramiteRequisitoRq, event: Event }>();

    constructor(public fieldsParserService: FieldsParserService, private fgbs: FormGroupBuilderService) {
    }

    ngOnInit() {
        console.log(`ngOnInit ->${this.constructor.name}`);
        if (this.rq && this.rq.idArchivoEstadoRq == 1) {//Si el requisito está completado parsear el valor
            this.fields$ = this.fieldsParserService.parseFields(this.rq.rqValue!);
        } else {//Si el requisito no está completado parsear la definicion.
            this.fields$ = this.fieldsParserService.parseFields(this.rq.reqDefinition!);
        }
        this.fields$.subscribe(fields => {
            this.fields = fields;
            this.form = this.fgbs.toFormGroup(this.fields as Field<string>[]);
        })
    }

    submitEvent(event: Event): void {
        event.preventDefault();
        const formRawValues = this.form.getRawValue();
        const parsedJson = transformFormToJson(formRawValues, this.fields!);
        this.rq.rqValue = JSON.stringify(parsedJson);
        this.rq.reqValue = JSON.stringify(parsedJson);
        this.onSubmitEmitter.emit({rq: this.rq, event});
    }
}
